// What the app copies from the live Shopify store's header, so its pages look
// like part of the store. Client-safe constants: StoreHeader renders them and
// tools/store-sync/check-store-sync.mjs compares them with the live store
// every day (.github/workflows/store-sync.yml) — when that check fails, copy
// the store's current values here.
//
// The live store is the source of truth, not shopify-theme/ in git: the theme
// editor rewrites the announcement bar without touching the repo, and the menu
// lives in Shopify's navigation settings, outside the theme altogether.

export const APP_URL = "https://app.recruitgraphics.com";

// Announcement bar slides, in order.
export const STORE_ANNOUNCEMENTS = [
  "QUALITY GRAPHICS IN 60 SECONDS",
  "YOUR GRAPHICS - YOUR CREATIVITY",
  "PROFIT FROM YOUR DESIGNS WITH A FREE NIL MERCH STORE",
];

// Main menu. Hrefs exactly as Shopify renders them: absolute, or relative to
// the store ("/search"), which storeHref resolves.
export const STORE_MENU = [
  { label: "Graphics", items: [
    { label: "Announcement", href: `${APP_URL}/start/announcement` },
    { label: "Print", href: `${APP_URL}/start/print` },
    { label: "Subscription", href: `${APP_URL}/subscription` },
  ] },
  { label: "NIL Partnership", items: [
    { label: "Athletes", href: "/search" },
    { label: "Partner Sign In", href: `${APP_URL}/nil/start` },
    { label: "About", href: `${APP_URL}/nil/about` },
  ] },
  { label: "Apparel", href: "/collections/featured" },
  { label: "Team Stores", items: [
    { label: "Teams", href: "/search" },
    { label: "Team Sign In", href: `${APP_URL}/team/start` },
    { label: "About", href: `${APP_URL}/team/about` },
  ] },
];

export function storeHref(href, storeBase) {
  return href.startsWith("/") ? `${storeBase.replace(/\/$/, "")}${href}` : href;
}
